import { useQuery } from "@tanstack/react-query";
import { Modal } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import AntTable from "../../../components/AntTable/AntTable";
import HeaderTableSuperAdmin from "../../../components/admin/common/HeaderTableSuperAdmin";
import PopAddNewClientAdmin from "../../../components/clients/PopAddNewClientAdmin";
import useBreadcrumb from "../../../hooks/useBreadcrumb";
import { getClientsAdmin } from "../../../network/admin";

type Props = {};
const actionItems = [
  {
    color: "#C43535",
    text: "Delete Client",
    title: "Confirm Deletion",
    description: "Are you sure you want to delete this client?",
    status: "delete",
  },
];
const UserManagement = (props: Props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [searchHeader, setSearchHeader] = useState();
  const [page, setPage] = useState<number>(1);
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState({
    title: "",
    para: "",
    status: "",
    color: "",
  });
  const [selectedClientId, setSelectedClientId] = useState<number | null>(null);
  const showModalConfirm = (
    title: string,
    para: string,
    status: string,
    color: string
  ) => {
    setConfirmMessage({ title, para, status, color });
    setIsModalConfirmOpen(true);
  };

  const closeModalConfirm = () => {
    setIsModalConfirmOpen(false);
  };
  const [isFilter, setIsFilter] = useState({});

  const { data, isLoading } = useQuery(
    ["clients", page, isFilter, searchHeader],
    () => getClientsAdmin({ page, ...isFilter, search: searchHeader })
  );
  const columns: ColumnsType<any> = [
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">User name</div>
      ),
      dataIndex: "first_name",
      render: (text: any, record) => (
        <div className="text-sm font-normal text-color-primary">
          {`${record?.profile?.first_name || record?.name} ${
            record?.profile?.last_name || ""
          }`}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          Associated salon{" "}
        </div>
      ),
      dataIndex: "salon name",
      // responsive: ["lg"],
      render: (text: any, record: any) => {
        const salonNames = record?.salons?.map((e: any) => e?.name).join(" - ");
        return (
          <div className="text-sm font-semibold text-color-primary" dir="ltr">
            {salonNames}
          </div>
        );
      },
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Email address</div>
      ),
      dataIndex: "display_all_booking",

      render: (text: any, record) => (
        <div className="text-sm font-normal text-color-primary">
          {record?.email}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Phone Number</div>
      ),
      dataIndex: "totalSales",

      render: (text: any, record) => (
        <div className="text-[#9999A7]">
          <span className="text-sm font-medium text-color-primary">
            {record?.phone}
          </span>
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          No. Appointments{" "}
        </div>
      ),
      dataIndex: "created_at",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="text-sm font-semibold text-color-primary">
          {record?.appointments_count}
        </div>
      ),
    },
    {
      title: <div></div>,
      dataIndex: "edit",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className="w-fit hover:bg-[#EEF0FF] p-2 rounded-full cursor-pointer"
          onClick={() => setSelectedClientId(record?.id)}
        >
          <AiOutlineEdit className="text-[#9999A7]" />
        </div>
      ),
    },
  ];
  const breadcrumb = useBreadcrumb([], 1);
  const deleteAppointment = (data: any) => {
    console.log(data);
  };
  return (
    <>
      {breadcrumb}
      <Modal
        width="60%"
        open={!!selectedClientId}
        onCancel={() => setSelectedClientId(null)}
        className="max-md:min-w-[95%] max-lg:min-w-[80%]"
        footer={null}
        destroyOnClose
      >
        {selectedClientId ? (
          <PopAddNewClientAdmin
            close={() => setSelectedClientId(null)}
            clientId={selectedClientId}
          />
        ) : null}
      </Modal>
      <div className="bg-[#EEF0FF] mt-20">
        <AntTable
          tableColumns={columns}
          tableHeader={
            <div className="flex items-center justify-end">
              <HeaderTableSuperAdmin
                searchHeader={searchHeader}
                setSearchHeader={setSearchHeader}
                placeholderSearch="Search users"
                selectedRowKeys={selectedRowKeys}
                labelButton="New user"
                setIsFilter={setIsFilter}
                filterType={{ dateAdded: true, bySalon: true }}
                modalId={2}
                actionItems={actionItems}
                confirmMessage={confirmMessage}
                requestDelete={deleteAppointment}
                setConfirmMessage={setConfirmMessage}
                isModalConfirmOpen={isModalConfirmOpen}
                closeModalConfirm={closeModalConfirm}
                showModalConfirm={showModalConfirm}
              />
            </div>
          }
          tableData={data?.data}
          isLoading={isLoading}
          expandRowByClick={false}
          // hideArrowExpand
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          selectionType={selectedRowKeys}
          setPage={setPage}
          page={page}
          total={data?.meta?.total}
        />
      </div>
    </>
  );
};

export default UserManagement;
